import { CatalogItem, UnitType } from "types";
import { xolaUri } from "../api/xolaUri";

export const getCatalogItemByTemplateId = (catalogItems: CatalogItem[], templateId: ID) => {
    return catalogItems.find((catalogItem: CatalogItem) => {
        return templateId === catalogItem.template?.id;
    });
};

export const getCatalogItemsByUnitType = <T extends CatalogItem>(
    catalogItems: CatalogItem[],
    unitType: UnitType,
): T[] => {
    return catalogItems.filter((catalogItem: CatalogItem) => catalogItem.unitType === unitType) as T[];
};

export const getCatalogItemTemplateIds = (catalogItems: CatalogItem[]) => {
    const templateIds: ID[] = [];
    for (const catalogItem of catalogItems) {
        if (catalogItem.template?.id) {
            templateIds.push(catalogItem.template.id);
        }
    }

    return templateIds;
};

export const getCatalogItemPhoto = (catalogItem: CatalogItem) => {
    return catalogItem.photo?.src ? `${xolaUri}${catalogItem.photo?.src}` : undefined;
};
